module.exports = __webpack_public_path__ + "img/KITANCESS+KITANCSMIS FR.d8cb2f3d.png";